@if (true) {
	<div class="card">
		<div class="card-header">
			<h4 class="card-title">RevClear</h4>
			@if (locations?.length > 0) {
				<ul class="nav-tools">
					<li>
						<a class="e-control e-btn e-lib e-success" (click)="openModalWithRefresh()" revTooltip tooltipContent="Add">
							<i class="fa fa-plus"></i>
						</a>
					</li>
				</ul>
			}
		</div>
		<div class="card-body">
			<div class="alert alert-warning">
				This should only be used if your Location has RevClear credentials
				which are not the same as your Practice level RevClear credentials
			</div>
			<rev-ag-grid-container [agGrid]="agGrid">
				<ng-container rev-table-action-menu-left>
					<div class="e-toolbar-item" [attr.data-test-id]="'revClearCredentialStatusSection'">
						<label>Status</label>
						<rev-status-select-button
							[(ngModel)]="statusFilter"
							[options]="statusFilterOptions"
							(onChange)="filterTable()"
							[attr.data-test-id]="'revClearCredentialStatusButton'">
						</rev-status-select-button>
					</div>
				</ng-container>
				<ng-container rev-container-grid>
					<ag-grid-angular
						#agGrid
						class="ag-theme-alpine"
						(gridReady)="onGridReady($event)"
						pmsAgAutoFitColumns
						[rowData]="revClearExternalCredentials"
						(rowDataUpdated)="filterTable()"
						[gridOptions]="gridOptions"
						(rowClicked)="openModalWithRefresh($event.data)"
						[attr.data-test-id]="'revClearCredentialTable'">
					</ag-grid-angular>
				</ng-container>
			</rev-ag-grid-container>
		</div>
	</div>
}

<ng-template #enableDisableButtonColumn let-data>
	@if (!data.active) {
		<rev-button
			[revGridButton]="'activate'"
			(buttonClick)="updateStatus(data)"
			dataTestId="encounterRolesActivateButton">
		</rev-button>
	}
	@if (data.active) {
		<rev-button
			[revGridButton]="'deactivate'"
			(buttonClick)="updateStatus(data)"
			dataTestId="encounterRolesDeactivateButton">
		</rev-button>
	}
</ng-template>
